/**
 * Joshua Alele-Beals
 * joshbeals22@gmail.com
 * github.com/joshBeals
 */

import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import { useAppState } from '../store/AppStateContext';
import capitalizeFirst from '../helpers/capitalizeFirst';
import generateYearRange from '../helpers/generateYearRange';

function ScenarioForm({ editingIndex, setEditingIndex }) {

    const { addScenario, updateScenario, scenarios } = useAppState();

    const [types, setTypes] = useState([]);
    const [convictionType, setConvictionType] = useState('');
    const [state, setState] = useState('michigan');
    const [states, setStates] = useState([]); 
    const currentYear = new Date().getFullYear();
    const years = generateYearRange(1960, currentYear);
    years.sort((a, b) => b - a);
    const [selectedYear, setSelectedYear] = useState('');
    // const [selectedDate, setSelectedDate] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);

    const isEditing = editingIndex !== null && editingIndex !== undefined;

    useEffect(() => {
        fetch('./law.json')
            .then(response => response.json())
            .then(data => {
                setStates(Object.keys(data));
                if (data && state && data[state]) {
                    setTypes(data[state]);
                }
        })
        .catch(error => console.error('Error loading the data', error));
    }, [state]); 

    useEffect(() => {
        if (isEditing && scenarios[editingIndex]) {
            const s = scenarios[editingIndex];
    
            setConvictionType(s.type || '');
            setSelectedYear(s.year || '');
            setIsChecked(!!s.assaultive);
            setIsChecked1(!!s.tenner);
            setIsChecked2(!!s.owi);
        }
    }, [editingIndex, scenarios]);    

    const handleStateChange = (e) => {
        setState(e.target.value)
    }

    const handleConvictionTypeChange = (event) => {
        setConvictionType(event.target.value);  
    };

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value); 
    };

    // const handleDateChange = (event) => {
    //     setSelectedDate(event.target.value);
    // };    

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleCheckboxChange1 = (event) => {
        setIsChecked1(event.target.checked);
    };

    const handleCheckboxChange2 = (event) => {
        setIsChecked2(event.target.checked);
    };

    const handleAdd = () => {
        if (convictionType != '' && selectedYear != '') {
            const count = scenarios.length;
            const id = `Date$${count}`;
            const result = { id: id, type: convictionType, year: selectedYear, assaultive: isChecked, tenner: isChecked1, owi: isChecked2 };
            addScenario(result);
            setConvictionType('');
            setSelectedYear('');
            setIsChecked(false);
            setIsChecked1(false);
            setIsChecked2(false);
        }
        
    };

    const resetForm = () => {
        setConvictionType('');
        setSelectedYear('');
        setIsChecked(false);
        setIsChecked1(false);
        setIsChecked2(false);
    };    
    
    const makeScenarioId = (scenarios) => `Date$${scenarios.length}`;

    const handleSubmit = () => {
        if (convictionType === '' || selectedYear === '') return;
    
        const payload = {
            id: isEditing ? scenarios[editingIndex].id : `Date$${scenarios.length}`,
            type: convictionType,
            year: selectedYear,
            assaultive: isChecked,
            tenner: isChecked1,
            owi: isChecked2,
        };
    
        if (isEditing) {
            updateScenario(editingIndex, payload);
            setEditingIndex(null);
        } else {
            addScenario(payload);
        }
    
        resetForm();
    };    

    return (
        <Card>
            <Card.Header>Add Conviction History</Card.Header>
            <Card.Body>
                <Form className='mb-3'>
                    <Row className='mb-3'>
                        <Col xs={12}>
                            <Form.Label>Choose State</Form.Label>
                            <Form.Select value={state} onChange={handleStateChange} disabled={state !== ""}>
                                <option>Select State</option>
                                {states?.map(state => (
                                    <option key={state} value={state}>{capitalizeFirst(state)}</option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                    {state != '' && (
                        <Row className="">
                            <Col xs={9}>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Select value={convictionType} onChange={handleConvictionTypeChange}>
                                            <option value="">Select Conviction Type</option>
                                            {types?.map((type, index) => (
                                                <option key={index} value={type}>{type}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Select value={selectedYear} onChange={handleYearChange}>
                                            <option value="">Select Year</option>
                                            {years.map(year => (
                                                <option key={year} value={year}>{year}</option>
                                            ))}
                                        </Form.Select>
                                        {/* <Form.Control
                                            type="date"
                                            placeholder='Select Date'
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                        /> */}
                                    </Col>
                                    <Col xs={3} className="mt-2">
                                        <Form.Check
                                            type="checkbox"
                                            label="Assaultive"
                                            checked={isChecked}
                                            onChange={handleCheckboxChange}
                                        />
                                    </Col>
                                    {convictionType.toLowerCase() === 'felony' && (
                                        <Col xs={3} className="mt-2">
                                            <Form.Check
                                                type="checkbox"
                                                label="TenYearFelony"
                                                checked={isChecked1}
                                                onChange={handleCheckboxChange1}
                                            />
                                        </Col>
                                    )}
                                    {convictionType.toLowerCase() === 'misdemeanor' && (
                                        <Col xs={3} className="mt-2">
                                            <Form.Check
                                                type="checkbox"
                                                label="OWI"
                                                checked={isChecked2}
                                                onChange={handleCheckboxChange2}
                                            />
                                        </Col>
                                    )}
                                </Row>
                            </Col>
                            <Col xs={3}>
                                <div>
                                    <Button
                                        onClick={handleSubmit}
                                        variant={isEditing ? "warning" : "outline-primary"}
                                        className="w-100"
                                    >
                                        {isEditing ? "Update" : "Add"}
                                    </Button>
                                    {isEditing && (
                                        <Button
                                            variant="outline-secondary"
                                            className="mt-2 w-100"
                                            onClick={() => {
                                                resetForm();
                                                setEditingIndex(null);
                                            }}
                                        >
                                            Cancel Edit
                                        </Button>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    )}
                </Form>
            </Card.Body>
        </Card>
    );
}

export default ScenarioForm;
